import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDataEntrega(api, parametros) {        
    parametros.operacao = 'buscarDataEntrega';

    let retorno = {};

    await api.santriGET('/rest/entrega', parametros, 25, false)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno; 
  },
  
  async buscarItensConfirmacaoSaidaProdutos(api, parametros) {       
    parametros.operacao = 'buscarItensConfirmacaoSaidaProdutos';

    let retorno = {};

    await api.santriGET('/rest/entrega', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async confirmarSaidaProdutos(api, parametros) {
    parametros.operacao = 'confirmarSaidaProdutos';

    let retorno = {};

    await api.santriPOST('/rest/entrega', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/REntrega.js